import { createContext } from "react";
import { FieldPermissionGrantDto } from "../../../common/data/service-proxies";

export interface IFieldPermissionsContext {
  fieldPermissions?: Array<FieldPermissionGrantDto>;
}

export const FieldPermissionsContext = createContext<IFieldPermissionsContext>(
  {}
);
